const caseInsensitiveSort = (a: string | undefined, b: string) => a !== undefined ?
 a.localeCompare(b, undefined, {sensitivity: 'base'}) : 1;
export default caseInsensitiveSort;
